import { c as _c } from "react/compiler-runtime";
import editIcon from '@images/renders/icon_images/edit.svg';
import { formatPrice } from '@lib/tools/_format-price';
import cl from 'classnames';
import { useEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import { useSelector } from 'react-redux';
import RangeSlider from '../range-slider/RangeSlider';
import style from './NewCalculatorSlider.module.scss';
export default function CalculatorSlider(props) {
  const $ = _c(53);
  const {
    label,
    incomingValue,
    onChange,
    readOnly,
    sliderValue,
    maxSliderValue: t0,
    minSliderValue: t1,
    initialPaymentPercent,
    initialPaymentPercentBase,
    percent,
    testId
  } = props;
  const maxSliderValue = t0 === undefined ? 0 : t0;
  const minSliderValue = t1 === undefined ? 0 : t1;
  const [inputValue, setInputValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const mortgageCalculatorName = useSelector(_temp);
  let t2;
  let t3;
  if ($[0] !== incomingValue) {
    t2 = () => {
      setInputValue(formatPrice(incomingValue, false));
    };
    t3 = [incomingValue];
    $[0] = incomingValue;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== onChange) {
    t4 = value => {
      onChange(Number.parseInt(value, 10));
    };
    $[3] = onChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const changeSliderValue = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      const newValue = event.target.value.replace(/\s/g, "");
      const numericValue = Number(newValue);
      setInputValue(formatPrice(numericValue, false));
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleInputChange = t5;
  let t6;
  if ($[6] !== incomingValue || $[7] !== maxSliderValue || $[8] !== minSliderValue || $[9] !== onChange) {
    t6 = event_0 => {
      const {
        value: value_0
      } = event_0.target;
      const number = Number.parseInt(value_0?.replace(/\s/g, ""));
      setIsFocused(false);
      if (!value_0 || Number.isNaN(number) || number < Number(minSliderValue) || number > Number(maxSliderValue)) {
        setInputValue(formatPrice(incomingValue, false));
        return;
      }
      onChange(Number(String(number).replace(/\s/g, "")));
    };
    $[6] = incomingValue;
    $[7] = maxSliderValue;
    $[8] = minSliderValue;
    $[9] = onChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleBlurInput = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event_1 => {
      const {
        key
      } = event_1;
      const isAllow = key === "Backspace" || key === "ArrowLeft" || key === "ArrowRight" || key === "Delete" || key === "Tab";
      if (!/^(?:\d|\s)$/.test(key) && !isAllow) {
        event_1.preventDefault();
      }
      if (key === "Enter") {
        inputRef?.current?.blur();
      }
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleKeyDown = t7;
  let t8;
  if ($[12] !== inputValue) {
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = /\s/g;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t8 = inputValue.replace(t9, "");
    $[12] = inputValue;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const numericInputValue = Number(t8);
  let t9;
  if ($[15] !== initialPaymentPercentBase || $[16] !== numericInputValue) {
    t9 = initialPaymentPercentBase > 0 && Number.isFinite(numericInputValue) ? Math.round(numericInputValue * 100 / initialPaymentPercentBase) : 0;
    $[15] = initialPaymentPercentBase;
    $[16] = numericInputValue;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const previewPercent = t9;
  const t10 = mortgageCalculatorName && mortgageCalculatorName === "finch" ? style.withoutPadding : "";
  let t11;
  if ($[18] !== t10) {
    t11 = cl(style.slider_block, t10);
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = !isFocused ? style.label : style.label__active;
  let t13;
  if ($[20] !== t12) {
    t13 = cl(t12);
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== label || $[23] !== t13) {
    t14 = <div className={t13}>{label}</div>;
    $[22] = label;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsFocused(true);
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== handleBlurInput || $[27] !== inputValue) {
    t16 = <input ref={inputRef} type="text" value={inputValue} onChange={handleInputChange} onFocus={t15} onBlur={handleBlurInput} onKeyDown={handleKeyDown} />;
    $[26] = handleBlurInput;
    $[27] = inputValue;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className={style.slider_cost__iconBox}><Svg src={editIcon.src} alt={"\u0418\u043A\u043E\u043D\u043A\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"} /></div>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== initialPaymentPercent) {
    t18 = initialPaymentPercent && <span className={style.slider_percent}>{initialPaymentPercent}</span>;
    $[30] = initialPaymentPercent;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== percent || $[33] !== previewPercent) {
    t19 = percent && <span className={style.slider_percent}>{Math.min(previewPercent, percent)}%</span>;
    $[32] = percent;
    $[33] = previewPercent;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t16 || $[36] !== t18 || $[37] !== t19 || $[38] !== testId) {
    t20 = <div className={style.slider_cost} data-testid={testId}>{t16}{t17}{t18}{t19}</div>;
    $[35] = t16;
    $[36] = t18;
    $[37] = t19;
    $[38] = testId;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const t21 = `${minSliderValue}-${maxSliderValue}`;
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = v => setInputValue(formatPrice(v, false));
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== changeSliderValue || $[42] !== maxSliderValue || $[43] !== minSliderValue || $[44] !== readOnly || $[45] !== sliderValue || $[46] !== t21) {
    t23 = <RangeSlider key={t21} value={sliderValue} min={minSliderValue} max={maxSliderValue} step={1} disabled={readOnly} onChange={t22} onChangeCommitted={changeSliderValue} />;
    $[41] = changeSliderValue;
    $[42] = maxSliderValue;
    $[43] = minSliderValue;
    $[44] = readOnly;
    $[45] = sliderValue;
    $[46] = t21;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t11 || $[49] !== t14 || $[50] !== t20 || $[51] !== t23) {
    t24 = <div className={t11}>{t14}{t20}{t23}</div>;
    $[48] = t11;
    $[49] = t14;
    $[50] = t20;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  return t24;
}
function _temp(state) {
  return state.projectinfo.mortgageCalculatorName;
}